import PropTypes from 'prop-types'
import Section from './section'
import React from 'react'

class Sections extends React.Component {

  static propTypes = {
    data: PropTypes.object,
    errors: PropTypes.object,
    fields: PropTypes.array,
    highlights: PropTypes.array,
    inline: PropTypes.bool,
    sections: PropTypes.array,
    status: PropTypes.string,
    tabIndex: PropTypes.number,
    onBusy: PropTypes.func,
    onReady: PropTypes.func,
    onSubmit: PropTypes.func,
    onUpdateData: PropTypes.func,
    onValid: PropTypes.func
  }

  render() {
    const { inline } = this.props
    const sections = this.props.sections.filter(section => section.show !== false)
    return (
      <div className={`maha-form-sections${inline ? ' inline' : ''}`}>
        { sections.map((section, index) => (
          <Section key={`section_${index}`} { ...this._getSection(section, index) } />
        )) }
      </div>
    )
  }

  _getSection(section, sectionIndex) {
    const { data, errors, fields, highlights, status, tabIndex, onBusy, onReady, onSubmit, onUpdateData, onValid } = this.props
    return {
      data,
      errors,
      fields,
      highlight: _.includes(highlights, `${tabIndex}-${sectionIndex}`),
      section,
      status,
      onBusy,
      onReady,
      onSubmit,
      onUpdateData,
      onValid
    }
  }

  _getTabIndexStart(section, index) {
    const { sections } = this.props
    return sections.reduce((start, section, i) => {
      return start + (i < index ? section.fields.length : 0)
    }, _.random(0,1000))
  }

}

export default Sections
